import { render, staticRenderFns } from "./main-menu.page.vue?vue&type=template&id=bd03a27e&scoped=true&"
import script from "./main-menu.page.vue?vue&type=script&lang=js&"
export * from "./main-menu.page.vue?vue&type=script&lang=js&"
import style0 from "./main-menu.page.vue?vue&type=style&index=0&id=bd03a27e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd03a27e",
  null
  
)

export default component.exports